export * from "ce/utils/licenseHelpers";
import { Button } from "@appsmith/ads";
import { WORKSPACE_SETTINGS_LICENSE_PAGE_URL } from "constants/routes";
import { createMessage, UPGRADE } from "ee/constants/messages";
import PageBannerMessage from "ee/pages/common/PageWrapperBanner";
import {
  getTenantId,
  isAdminUser,
  isFreePlan,
  isTrialLicense,
  shouldShowLicenseBanner,
} from "ee/selectors/organizationSelectors";
import { isAirgapped } from "ee/utils/airgapHelpers";
import AnalyticsUtil from "ee/utils/AnalyticsUtil";
import { customerPortalPlansUrl } from "ee/utils/billingUtils";
import { useIsCloudBillingEnabled } from "hooks/useIsCloudBillingEnabled";
import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { useRouteMatch } from "react-router";
import { getCurrentUser } from "selectors/usersSelectors";
import store from "store";

export const getLicenseKey = () => {
  const state = store.getState();
  const licenseKey =
    state?.organization?.organizationConfiguration?.license?.key;

  return licenseKey || "";
};

export const pricingPageUrlSource = "BE";

export const ShowUpgradeMenuItem = () => {
  const isTrial = useSelector(isTrialLicense);
  const isAdmin = useSelector(isAdminUser);
  const isFree = useSelector(isFreePlan);
  const isAirgappedInstance = isAirgapped();
  const currentUser = useSelector(getCurrentUser);
  const organizationId = useSelector(getTenantId);

  const isCloudBillingEnabled = useIsCloudBillingEnabled();

  const handleUpgrade = useCallback(() => {
    AnalyticsUtil.logEvent("UPGRADE_CLICK", {
      organization_id: organizationId,
      user_id: currentUser?.username,
      source: "upgrade_menu_item",
    });

    if (isCloudBillingEnabled) {
      window.location.href = WORKSPACE_SETTINGS_LICENSE_PAGE_URL;
    } else {
      window.open(customerPortalPlansUrl, "_blank");
    }
  }, [isCloudBillingEnabled, currentUser?.username, organizationId]);

  return (isTrial || isFree) && isAdmin && !isAirgappedInstance ? (
    <Button
      className="business-plan-menu-option mr-2"
      data-testid="t--upgrade-to-business"
      kind="secondary"
      onClick={handleUpgrade}
    >
      {createMessage(UPGRADE)}
    </Button>
  ) : null;
};

export const Banner = () => {
  const showBanner = useSelector(shouldShowLicenseBanner);
  const isHomePage = useRouteMatch("/applications")?.isExact;
  const isLicensePage = useRouteMatch("/license")?.isExact;

  return showBanner && (isHomePage || isLicensePage) ? (
    <PageBannerMessage />
  ) : null;
};
